/* Customer videos.

   In the theme: assets/nextdev-pdp-ugc-videos.js, loaded by
   snippets/nextdev-pdp-gives-back.liquid for the videos in the gives-back
   card. Elements are looked up by the data attributes beside the
   nextdev--pdp__ugc-videos-* classes. */

// The small video beside the title plays without sound while it is on
// screen and stops when it leaves; a tap on it opens the reel on the first
// video. A tap on a tile opens the reel on that video, playing, with its sound,
// since the tap is the visitor asking for it. One video element moves into
// whichever slide is playing and takes that slide's source; the rest show
// their posters, so nothing is fetched until it is asked for. The controls
// are the gallery's: the button in the corner plays and pauses, the line
// across the top says how far along, and a tap on the video does what the
// button does. When one ends the next plays, up to the last. With a mouse the row of tiles drags sideways, since its
// scrollbar is not drawn, and the video in the dialog swipes as it does
// under a finger; a drag is never read as a tap.
(function () {
  'use strict';

  function setup(box) {
    if (box.dataset.nextdevPdpUgcVideosInit) return;
    box.dataset.nextdevPdpUgcVideosInit = 'true';

    var track = box.querySelector('[data-nextdev-pdp-ugc-videos-track]');
    var tiles = Array.prototype.slice.call(box.querySelectorAll('[data-nextdev-pdp-ugc-video]'));
    var dialog = box.querySelector('[data-nextdev-pdp-ugc-videos-dialog]');
    if (!tiles.length || !dialog || !dialog.showModal) return;

    var q = function (sel) { return dialog.querySelector(sel); };
    var viewer = q('[data-nextdev-pdp-ugc-videos-viewer]');
    var reel = q('[data-nextdev-pdp-ugc-videos-reel]');
    var strip = q('[data-nextdev-pdp-ugc-videos-thumbs]');
    var status = q('[data-nextdev-pdp-ugc-videos-status]');
    var player = q('[data-nextdev-pdp-ugc-videos-player]');
    var progress = q('[data-nextdev-pdp-ugc-videos-progress]');
    var watch = q('[data-nextdev-pdp-ugc-videos-watch]');
    var watchLabel = q('[data-nextdev-pdp-ugc-videos-watch-label]');
    var prev = q('[data-nextdev-pdp-ugc-videos-prev]');
    var next = q('[data-nextdev-pdp-ugc-videos-next]');
    var close = q('[data-nextdev-pdp-ugc-videos-close]');
    var clip = box.querySelector('[data-nextdev-pdp-ugc-videos-clip]');
    var clipVideo = clip && clip.querySelector('video');

    // ---- the reel and the strip, drawn once from the tiles ----
    var slides = [];
    var thumbs = [];
    tiles.forEach(function (tile, i) {
      var poster = tile.getAttribute('data-poster');
      var slide = document.createElement('div');
      slide.className = 'nextdev--pdp__ugc-videos-slide';
      slide.setAttribute('role', 'button');
      slide.setAttribute('tabindex', '-1');
      slide.setAttribute('aria-label', 'Play video ' + (i + 1) + ' of ' + tiles.length);
      var img = document.createElement('img');
      img.className = 'nextdev--pdp__ugc-videos-poster';
      img.src = poster;
      img.alt = '';
      img.loading = 'lazy';
      img.draggable = false;
      slide.appendChild(img);
      slide.addEventListener('click', function () {
        if (i !== at) go(i, true);
      });
      reel.appendChild(slide);
      slides.push(slide);

      var li = document.createElement('li');
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'nextdev--pdp__ugc-videos-thumb';
      thumb.setAttribute('aria-label', 'Video ' + (i + 1) + ' of ' + tiles.length);
      var small = document.createElement('img');
      small.src = poster;
      small.alt = '';
      small.loading = 'lazy';
      thumb.appendChild(small);
      thumb.addEventListener('click', function () { go(i, true); });
      li.appendChild(thumb);
      strip.appendChild(li);
      thumbs.push(thumb);
    });

    var at = 0;
    var opener = null;

    // ---- the gallery's controls ----
    function playing(on) {
      watch.classList.toggle('nextdev--pdp__watch--playing', on);
      watch.setAttribute('aria-pressed', on ? 'true' : 'false');
      watchLabel.textContent = on ? 'Pause video' : 'Watch video';
    }

    function mark() {
      var along = player.duration ? player.currentTime / player.duration : 0;
      progress.style.setProperty('--nextdev-pdp-progress', (along * 100).toFixed(2) + '%');
      progress.classList.toggle('nextdev--pdp__video-progress--on', along > 0 || !player.paused);
    }

    function toggle() {
      if (player.paused) {
        var started = player.play();
        if (started && started.catch) started.catch(function () { playing(false); });
      } else {
        player.pause();
      }
    }

    watch.addEventListener('click', toggle);
    player.addEventListener('click', toggle);
    player.addEventListener('play', function () { playing(true); mark(); });
    player.addEventListener('pause', function () { playing(false); });
    player.addEventListener('timeupdate', mark);
    // a video that ends moves on to the next, playing; the last stops and
    // goes back to its start rather than round to the first
    player.addEventListener('ended', function () {
      if (at < tiles.length - 1) {
        go(at + 1, true);
        return;
      }
      playing(false);
      player.currentTime = 0;
      mark();
    });

    // ---- moving along ----
    // the reel slides so the one playing sits in the middle; offsetLeft
    // is read before any scale, so the smaller ones either side do not
    // throw the sum out
    function centre() {
      var slide = slides[at];
      var x = viewer.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);
      reel.style.transform = 'translateX(' + Math.round(x) + 'px)';
    }

    function go(i, play) {
      at = Math.max(0, Math.min(tiles.length - 1, i));
      player.pause();
      slides.forEach(function (sl, k) {
        var on = k === at;
        sl.classList.toggle('nextdev--pdp__ugc-videos-slide--active', on);
        sl.setAttribute('tabindex', on ? '-1' : '0');
      });
      thumbs.forEach(function (th, k) {
        th.classList.toggle('nextdev--pdp__ugc-videos-thumb--active', k === at);
        if (k === at) th.setAttribute('aria-current', 'true'); else th.removeAttribute('aria-current');
      });

      // the one video, its line and its button move into the slide
      var slide = slides[at];
      slide.appendChild(progress);
      slide.appendChild(watch);
      slide.appendChild(player);
      player.poster = tiles[at].getAttribute('data-poster');
      player.src = tiles[at].getAttribute('data-src');
      progress.style.setProperty('--nextdev-pdp-progress', '0%');
      progress.classList.remove('nextdev--pdp__video-progress--on');
      playing(false);

      prev.disabled = at === 0;
      next.disabled = at === tiles.length - 1;
      status.textContent = 'Video ' + (at + 1) + ' of ' + tiles.length;

      centre();
      // the strip keeps the one playing in view, and only the strip moves
      var th = thumbs[at];
      var left = th.parentNode.offsetLeft - (strip.clientWidth - th.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });

      if (play) toggle();
    }

    function openAt(i, from) {
      opener = from || null;
      clipPlay(false);
      document.documentElement.classList.add('nextdev--pdp__ugc-videos-locked');
      dialog.showModal();
      // opened with nothing moving, so it lands where it belongs
      reel.style.transition = 'none';
      go(i, true);
      reel.offsetWidth;
      reel.style.transition = '';
      close.focus();
    }

    // escape, the X and the ground around the reel all end here
    dialog.addEventListener('close', function () {
      player.pause();
      player.removeAttribute('src');
      player.load();
      document.documentElement.classList.remove('nextdev--pdp__ugc-videos-locked');
      if (opener) opener.focus({ preventScroll: true });
      clipPlay(clipSeen);
    });

    close.addEventListener('click', function () { dialog.close(); });
    prev.addEventListener('click', function () { go(at - 1, true); });
    next.addEventListener('click', function () { go(at + 1, true); });
    dialog.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dialog || t === viewer || t === reel || t === strip) dialog.close();
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1, true); }
    });
    window.addEventListener('resize', function () { if (dialog.open) centre(); });

    // a swipe across the video steps along, with a finger or a mouse, since
    // a phone draws no arrows and a narrow window on a computer shows the
    // phone's layout; the click a mouse swipe ends in is not read as a tap,
    // so it neither plays the video nor closes the dialog
    var swipe = null;
    var swiped = false;
    viewer.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      swipe = { x: e.clientX, y: e.clientY };
      swiped = false;
    });
    viewer.addEventListener('pointerup', function (e) {
      if (!swipe) return;
      var dx = e.clientX - swipe.x;
      var dy = e.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(at + (dx < 0 ? 1 : -1), true);
      }
    });
    viewer.addEventListener('pointercancel', function () { swipe = null; });
    viewer.addEventListener('click', function (e) {
      if (!swiped) return;
      swiped = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // ---- the row of tiles on the page ----
    // the mouse drags the row; touch and a trackpad scroll it natively
    var drag = null;
    var dragged = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft };
      dragged = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!dragged && Math.abs(dx) > 4) {
        dragged = true;
        track.classList.add('nextdev--pdp__ugc-videos-track--dragging');
      }
      if (dragged) track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null;
      track.classList.remove('nextdev--pdp__ugc-videos-track--dragging');
    });

    // ---- the small video beside the title ----
    // muted and inline, as Safari asks before it plays a video on its own;
    // its file is fetched only the first time it comes on screen, as a
    // stream where the browser plays one, so a small box takes a small
    // size, and as the mp4 elsewhere. Where motion is turned down, or the
    // phone saves power and refuses, it stays its poster.
    var clipSeen = false;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clipPlay(on) {
      if (!clipVideo) return;
      if (!on || still || dialog.open) {
        clipVideo.pause();
        return;
      }
      if (!clipVideo.getAttribute('src')) {
        var stream = clipVideo.getAttribute('data-stream');
        clipVideo.src = stream && clipVideo.canPlayType('application/vnd.apple.mpegurl')
          ? stream
          : clipVideo.getAttribute('data-src');
      }
      clipVideo.muted = true;
      clipVideo.defaultMuted = true;
      clipVideo.playsInline = true;
      var started = clipVideo.play();
      if (started && started.catch) started.catch(function () {});
    }

    if (clip) {
      clip.addEventListener('click', function () { openAt(0, clip); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            clipSeen = entry.isIntersecting;
            clipPlay(clipSeen);
          });
        }, { threshold: 0.25 }).observe(clip);
      }
      // a phone that sleeps or a tab put away stops it; coming back starts it
      document.addEventListener('visibilitychange', function () {
        clipPlay(clipSeen && !document.hidden);
      });
    }

    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function (e) {
        if (dragged) {
          e.preventDefault();
          dragged = false;
          return;
        }
        openAt(i, tile);
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-nextdev-pdp-ugc-videos]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor draws a section again after a change
  document.addEventListener('shopify:section:load', start);
})();
